const dev = {
  api: {
    BASEURL: 'https://localhost:5050/'
  },
  adobe: {
    CLIENT_ID: 'd3fd3109fb8f40899278a8f24e6443d3'
  },
  mapBox: {
    token: 'pk.eyJ1IjoicGxvdnkiLCJhIjoiY2x2djNla2oyMXAwYjJpbzY5aW5uNjdtcSJ9.jfUHS5AWhTNs3yI-I0sTuQ'
  }
}

const stage = {
  api: {
    BASEURL: 'https://api.stage.campaign-preview.net/'
  },
  adobe: {
    CLIENT_ID: ''
  },
  mapBox: {
    token: 'pk.eyJ1IjoicGxvdnkiLCJhIjoiY2x2djNla2oyMXAwYjJpbzY5aW5uNjdtcSJ9.jfUHS5AWhTNs3yI-I0sTuQ'
  }
}

const prod = {
  api: {
    BASEURL: 'https://api.campaign-preview.net/'
  },
  adobe: {
    CLIENT_ID: '9b3944c866914f7ca1864d34ea7a10be'
  },
  mapBox: {
    token: 'pk.eyJ1IjoicGxvdnkiLCJhIjoiY204dGNrbXh6MDlzbzJucTNzcW53bXl0aCJ9.CCkrij2uV_0J3AuIXZBXVg'
  }
}

let config

switch (process.env.REACT_APP_ENV) {
  case 'Staging':
    config = stage
    break

  case 'Development':
    config = dev
    break

  default:
    config = prod
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  TIMEOUT: 1500,
  ...config
}
